// ignore-string-externalization

/* stylelint-disable value-keyword-case */
import styled, { css } from 'styled-components';
import { screenXsMax, screenSmMin, spacer16, spacer24, spacer40 } from '@spotify-internal/encore-foundation';
export var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "fvyvpw-0"
})(["", " ", " ", " ", ""], function (_ref) {
  var flex = _ref.flex;
  return flex && css(["flex:", ";"], flex);
}, function (_ref2) {
  var noPadding = _ref2.noPadding;
  return !noPadding && css(["@media (max-width:", "){padding:", " ", ";}@media (min-width:", "){padding:", " ", ";}"], screenXsMax, spacer24, spacer16, screenSmMin, spacer24, spacer40);
}, function (_ref3) {
  var theme = _ref3.theme;
  return css(["background:", ";color:", ";"], theme.box.background, theme.box.text);
}, function (_ref4) {
  var transparent = _ref4.transparent;
  return transparent && css(["background:transparent;"]);
});
export var Stack = styled.div.withConfig({
  displayName: "Box__Stack",
  componentId: "fvyvpw-1"
})(["display:flex;flex-direction:column;width:100%;height:100%;"]);
export var ImageAspectBox = styled.div.withConfig({
  displayName: "Box__ImageAspectBox",
  componentId: "fvyvpw-2"
})(["position:relative;&::after{content:'';display:block;padding-bottom:", "%;}video,img,iframe,embed{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:", ";}"], function (props) {
  return (props === null || props === void 0 ? void 0 : props.ratio) * 100;
}, function (props) {
  return props.fit || 'cover';
});
export var ImageAspectBox1x1 = styled(ImageAspectBox).attrs({
  ratio: 1,
  'data-aspect-ratio': '1x1'
}).withConfig({
  displayName: "Box__ImageAspectBox1x1",
  componentId: "fvyvpw-3"
})([""]);
export var ImageAspectBox16x9 = styled(ImageAspectBox).attrs({
  ratio: 9 / 16,
  'data-aspect-ratio': '16x9'
}).withConfig({
  displayName: "Box__ImageAspectBox16x9",
  componentId: "fvyvpw-4"
})([""]);
export var ImageAspectBox21x9 = styled(ImageAspectBox).attrs({
  ratio: 9 / 21,
  'data-aspect-ratio': '21x9'
}).withConfig({
  displayName: "Box__ImageAspectBox21x9",
  componentId: "fvyvpw-5"
})([""]);
export var ImageAspectBox5x4 = styled(ImageAspectBox).attrs({
  ratio: 4 / 5,
  'data-aspect-ratio': '5x4'
}).withConfig({
  displayName: "Box__ImageAspectBox5x4",
  componentId: "fvyvpw-6"
})([""]);
export var ImageAspectBox3x5 = styled(ImageAspectBox).attrs({
  ratio: 5 / 3,
  'data-aspect-ratio': '3x5'
}).withConfig({
  displayName: "Box__ImageAspectBox3x5",
  componentId: "fvyvpw-7"
})([""]);
export var ImageAspectBox1x2 = styled(ImageAspectBox).attrs({
  ratio: 2 / 1,
  'data-aspect-ratio': '1x2'
}).withConfig({
  displayName: "Box__ImageAspectBox1x2",
  componentId: "fvyvpw-8"
})([""]);